import {
  Button,
  Flex,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
  Text,
  Box,
} from '@chakra-ui/react';
import { Controller, useForm } from 'react-hook-form';
import { OS_OPTIONS } from '../constant';

export default function OsOptionModal(props) {
  const { onClose, requests, isLoading } = props;

  const { handleSubmit, control } = useForm({
    defaultValues: { os: "amazon" }
  });

  return (
    <Modal
      closeOnOverlayClick={false}
      onClose={onClose}
      size="md"
      isOpen={true}
      isCentered
      motionPreset="scale"
    >
      <form onSubmit={handleSubmit(requests)}>
        <ModalOverlay />
        <ModalContent borderRadius="xl" py={4} shadow="lg">
          <ModalCloseButton />
          <ModalBody>
            <Text
              fontSize="lg"
              fontWeight="bold"
              textAlign="center"
              mt={4}
              mb={6}
              color="gray.800"
            >
              Please select your preferred OS
            </Text>

            <Controller
              control={control}
              name="os"
              render={({ field }) => (
                <RadioGroup {...field}>
                  <Stack spacing={3}>
                    {OS_OPTIONS.map((item) => (
                      <Box
                        key={item.value}
                        as="label"
                        borderWidth="1px"
                        borderRadius="md"
                        px={4}
                        py={3}
                        cursor="pointer"
                        _hover={{ borderColor: "teal.400", bg: "gray.50" }}
                        borderColor={field.value === item.value ? "teal.500" : "gray.200"}
                        bg={field.value === item.value ? "teal.50" : "white"}
                        transition="all 0.2s"
                      >
                        <Flex align="center" justifyContent="space-between" gap={3}>
                          <Flex align="center" gap={3}>
                            <Image
                              src={item.image}
                              alt={"vm instance"}
                              boxSize="40px"
                              objectFit="contain"
                              borderRadius="full"
                              background="#eee"
                            />
                            <Text fontWeight="medium">{item.label}</Text>
                          </Flex>
                          <Radio
                            value={item.value}
                            colorScheme="teal"
                            isChecked={field.value === item.value}
                            display="flex"
                          />
                        </Flex>
                      </Box>
                    ))}
                  </Stack>
                </RadioGroup>
              )}
            />

            <Flex mt={8} justify="flex-end">
              <Button
                type="submit"
                background="green.500"
                color="white"
                _hover={{ background: "green.600" }}
                _active={{ background: "green.700" }}
                borderRadius="md"
                fontWeight="semibold"
                minW="120px"
                height="44px"
                isDisabled={isLoading}
              >
                {isLoading ? <Spinner size="sm" /> : "Confirm"}
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </form>
    </Modal>
  );
}
